
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Loader from "../components/Loader.vue";
import VueApexCharts from "vue-apexcharts";
import { AnalyticFilter, Dict } from "@gsx/common";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import { AnalyticFavoriteManager } from "../../utils/AnalyticFavoriteManager";
import FavoriteBtn from "../components/FavoriteBtn.vue";
import { AnalyticFiltering } from "./AnalyticFiltering";

@Component({ components: { Loader, VueApexCharts, FavoriteBtn } })
export default class InHouseManufacturing extends Vue {
    @Prop() readonly chartHeight!: string;
    @Prop() readonly analyticFilter?: AnalyticFilter;
    @Inject("container") readonly container!: Container;
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    analyticFavoriteManager: AnalyticFavoriteManager = this.container.get(AnalyticFavoriteManager);
    analyticFiltering: AnalyticFiltering = this.container.get(AnalyticFiltering);

    get isFavorite() {
        // @ts-ignore
        return this.analyticFavoriteManager.isFavorite(this.$options._componentTag);
    }

    async toggleFavorite() {
        // @ts-ignore
        await this.analyticFavoriteManager.toggleFavorite(this.$options._componentTag);
    }

    get inHouseManufacturingChart() {
        let items = [];
        if (this.analyticFilter) {
            items = this.analyticFiltering.filteredItems(this.analyticFilter);
        } else {
            items = this.organizationListStore.filteredItems;
        }

        const manufacturing = items
            .flatMap((organization) => organization.manufactureInternal || [])
            .reduce((prev: Dict, curr: string) => {
                prev[curr] = prev[curr] ? prev[curr] + 1 : 1;
                return prev;
            }, {});

        return {
            chartOptions: {
                labels: Object.keys(manufacturing),
            },
            series: Object.values(manufacturing),
        };
    }
}
